import { ArrowRightOutlined, CalculatorOutlined } from '@ant-design/icons';
import { Button, Row, Tooltip } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

const NextButton = (
  {
    showCount,
    noPartialSum,
    handleStep,
    isStepIncreaseDisabled
  }: {
    showCount:boolean,
    noPartialSum:boolean,
    handleStep: ()=>void,
    isStepIncreaseDisabled:boolean,
  }
) => {
  const { t } = useTranslation();
  if (showCount) {
    return (
      <Button
        type="primary"
        onClick={handleStep}
        icon={<CalculatorOutlined />}
      >
        {t('nextButton.calc')}
      </Button>
    );
  }
  return (
    <Tooltip title={noPartialSum ? 'Add at least one data to go further. To do so fill all required forms & and press +Add data' : ''} color="blue">
      <Button type="primary" onClick={handleStep} disabled={isStepIncreaseDisabled || noPartialSum}>
        <Row align="middle">
          {t('nextButton.next')}
          <ArrowRightOutlined style={{ marginLeft: 6 }} />
        </Row>
      </Button>
    </Tooltip>
  );
};

export default React.memo(NextButton);


const texts = {
  next: 'Dalej',
  count: 'Oblicz',
};
